import { VALUE_IS_REQUIRED } from '@/components/composed/forms/form-errors';

export function validatePerformanceTarget(args: string) {
  return args ? undefined : VALUE_IS_REQUIRED;
}

export function validatePopulation(args: API.UIMetrics.PopulationFieldType) {
  return args?.value ? undefined : VALUE_IS_REQUIRED;
}
